module.exports = __webpack_public_path__ + "media/images/menu/virgo-0d69f32ac2ffc340cd6cc1578f2fef3d.jpg";